import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import store from '@/state/store'
import routes from './routes'

Vue.use(VueRouter)
Vue.use(VueMeta, {
  keyName: 'page',
})

// ✅ Parchear push/replace para ignorar errores de redirect/duplicados
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => {
    if (
      err &&
      (err.name === 'NavigationDuplicated' ||
        (typeof err.message === 'string' &&
          err.message.includes('Redirected when going from')))
    ) {
      // Ignorar estos errores
      return err
    }
    throw err
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(err => {
    if (
      err &&
      (err.name === 'NavigationDuplicated' ||
        (typeof err.message === 'string' &&
          err.message.includes('Redirected when going from')))
    ) {
      // Ignorar estos errores
      return err
    }
    throw err
  })
}

// 🔹 Obtener perfil desde localStorage (clave "profile")
function getUserProfile() {
  const raw = localStorage.getItem('profile')
  if (!raw) return null

  try {
    const parsed = JSON.parse(raw)   // por si guardas 5 o "5"
    return Number(parsed)
  } catch (e) {
    return Number(raw)               // por si guardas solo "5"
  }
}

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

router.beforeEach((to, from, next) => {
  const authRequired = to.matched.some(record => record.meta.requireAuth)
  const token = store.state.auth.token

  // 1️⃣ Si la ruta requiere auth y NO hay token → al login
  if (authRequired && !token) {
    if (to.name !== 'login') {
      return next({ name: 'login' })
    }
    return next()
  }

  // 2️⃣ Si la ruta NO requiere auth → pasa sin validar perfil
  if (!authRequired) {
    return next()
  }

  // 3️⃣ Rutas protegidas: validar perfil contra allowedProfiles
  const profile = getUserProfile()
  const allowedProfiles = to.meta.allowedProfiles

  if (allowedProfiles && !allowedProfiles.includes(profile)) {
    // Perfil 5 → solo puede ir a compras
    if (profile === 5) {
      if (to.path !== '/compras/automatizacion') {
        return next({ path: '/compras/automatizacion' })
      }
      // ya está en compras y aun así no tiene permiso → cancelar
      return next(false)
    }

    // Otros perfiles sin permiso → al login
    if (to.name !== 'login') {
      return next({ name: 'login' })
    }
    return next(false)
  }

  // ✅ Todo OK
  next()
})

export default router
